"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountries = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const getCountries = query => (0, _request.default)({
  url: '/countries',
  method: 'get',
  params: query
});
exports.getCountries = getCountries;